import { Dialog, DialogActions, DialogContent, DialogTitle, Link as MuiLink, Stack, Typography } from '@mui/material';
import { Routes } from 'enums';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import useLimitReachedStore from 'stores/limit-reached-store';
import { makeStyles } from 'tss-react/mui';
import PaiLink from '../base-components/pai-link';

const LimitReachedDialog: React.FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const { limitReached, handleCloseLimitReachedDialog } = useLimitReachedStore((state) => ({
    limitReached: state.limitReached,
    handleCloseLimitReachedDialog: state.handleCloseLimitReachedDialog,
  }));

  return (
    <Dialog open={limitReached} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('limitReachedDialogTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>{t('limitReachedDialogContent1')}</Typography>
          <Typography className={classes.text}>
            <Trans i18nKey={'limitReachedDialogContent2'}>
              Bitte
              <Link className={classes.link} to={Routes.UPGRADE} target={'_blank'}>
                upgrade deine Lizenz
              </Link>
              , oder
              <MuiLink className={classes.link} href={'mailto:simon.tschuertz@secret-ai-agent.de'} target={'_blank'}>
                kontaktiere uns
              </MuiLink>
              , wenn du einen speziellen Plan für dich oder dein Unternehmen benötigst.
            </Trans>
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('close')} size={'sm'} underline={'always'} action={handleCloseLimitReachedDialog} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    background: theme.palette.primary.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '16px 16px 24px 16px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
    '&.highlight': {
      color: theme.palette.primary.main,
    },
  },
  link: {
    fontSize: theme.typography.pxToRem(15),
    textDecoration: 'underline',
    color: theme.palette.primary.main,
    textUnderlineOffset: '4px',
    '&:hover': {
      textDecoration: 'underline',
      color: theme.palette.secondary.main,
    },
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default LimitReachedDialog;
